import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import useNavigationStore from '../stores/navigation';

const useNavigationState = () => {
  const navigationStore = useNavigationStore();
  const { navigationFlags, hasNavigationFlags } = storeToRefs(navigationStore);
  const { setNavigationFlag, resetNavigationFlags } = navigationStore;

  const manualNavigation = ref(false);
  const suppressDrawerAndControls = ref(false);
  const currentEventCFILocation = ref<string | undefined>(undefined);

  const triggerFlag = (key: keyof typeof navigationFlags.value) => {
    setNavigationFlag(key, true);
  };

  /**
   * Resets UI suppression on the next animation frame to prevent
   * flickering during rapid page turns.
   */
  const tempSuppressUI = () => {
    suppressDrawerAndControls.value = true;
    requestAnimationFrame(() => {
      suppressDrawerAndControls.value = false;
    });
  };

  return {
    manualNavigation,
    suppressDrawerAndControls,
    currentEventCFILocation,
    flags: navigationFlags,
    hasFlags: hasNavigationFlags,
    triggerFlag,
    tempSuppressUI,
    resetFlags: resetNavigationFlags,
  };
};

export default useNavigationState;
